import React from 'react';
import './PC.css';
import Aronsson from '../../img/pc/Aronsson.png'
import Bloch from '../../img/pc/Bloch.png'
import Canonical from '../../img/pc/Canonical.png'
import eBay from '../../img/pc/eBay.png'
import Grigorescu from '../../img/pc/Grigorescu.png'
import Pattanaik from '../../img/pc/Pattanaik.png'
import PublicisSapient from '../../img/pc/PublicisSapient.png'
import Pushkarev from '../../img/pc/Pushkarev.png'
import Valenzuela from '../../img/pc/Valenzuela.png'
import Microsoft from '../../img/pc/Microsoft.png'
import Movva from '../../img/pc/Movva.png'
import Tamegue from '../../img/pc/Tamegue.png'

export default class PC extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      speakers: [
        {
          photo: Grigorescu,
          name: 'Bogdan Grigorescu',
          position: 'Sr Tech Lead, Architecture and Integration',
          ln: 'https://www.linkedin.com/in/bogdan-g/',
          logo: eBay,
        },
        {
          photo: Aronsson,
          name: 'Simon Aronsson',
          position: 'Senior Engineering Manager',
          ln: 'https://www.linkedin.com/in/simonaronsson/',
          github: 'https://github.com/simskij',
          logo: Canonical,
        },
        {
          photo: Pattanaik,
          name: 'Subhasish Pattanaik',
          position: 'Test Manager',
          ln: 'https://www.linkedin.com/in/subhasishpattanaik/',
        },
        {
          photo: Pushkarev,
          name: 'Alexander Pushkarev',
          position: 'Software Craftsperson',
          ln: 'https://www.linkedin.com/in/alexpushkarev/',
        },
        {
          photo: Bloch,
          name: 'Gaëtan Bloch',
          position: 'Software Architect',
          ln: 'https://www.linkedin.com/in/gaetanbloch/',
          tw: 'https://twitter.com/bloch_gaetan',
          github: 'https://github.com/gaetanBloch',
          logo: PublicisSapient,
        },
        {
          photo: Valenzuela,
          name: 'Jorge Valenzuela',
          position: 'Cloud Native Architecture & DevOps Director',
          ln: 'https://www.linkedin.com/in/jorge-valenzuela-jimenez/',
          tw: 'https://twitter.com/jj_tel',
          logo: Microsoft,
        },
        {
          photo: Movva,
          name: 'Prasanth Sai Movva',
          position: 'DevOps Engineer',
          ln: 'https://www.linkedin.com/in/prasanthmovva/',
          github: 'https://github.com/prasanthmovvaamz',
        },
        {
          photo: Tamegue,
          name: 'Jules Pericles Tamegue',
          position: 'Lead Devops Engineer',
          ln: 'https://www.linkedin.com/in/julessaurel/',
        },
      ],
    }
  }

  renderPC(item, i) {
    return (
      <div className="pc_item" key={`team-${i}`}>
        <div className='pc_info' style={{ backgroundImage: `url(${item.photo}` }}>
          <p className="pc_name p1">{item.name}</p>
          <p className="pc_position p2 grey">{item.position}</p>
          <img className='pc_logo' src={item.logo} alt="" />
          <div className="pc_links">
            {item.fb && <a className="social_link social_fb" target='_blank' rel="noreferrer" href={item.fb}></a>}
            {item.ln && <a className="social_link social_ln" target='_blank' rel="noreferrer" href={item.ln}></a>}
            {item.tw && <a className="social_link social_tw" target='_blank' rel="noreferrer" href={item.tw}></a>}
            {item.github && <a className="social_link social_github" target='_blank' rel="noreferrer" href={item.github}></a>}
            {item.website && <a className="social_link social_website" target='_blank' rel="noreferrer" href={item.website}></a>}
            {item.youtube && <a className="social_link social_yb" target='_blank' rel="noreferrer" href={item.youtube}></a>}
            {item.twitch && <a className="social_link social_twitch" target='_blank' rel="noreferrer" href={item.twitch}></a>}
          </div>
        </div>
      </div>
    )
  }

  render() {
    return (
      <div className="pc_wrap pc_wrap--mb" id='pcc'>
        <div className='container pc'>
          <h2 className='pc_title pc_main'>Program <span className='title_gradient'>committee</span></h2>
          <div className='pc_block'>
            {this.state.speakers.map((item, i) => this.renderPC(item, i))}
          </div>
        </div>
      </div>
    )
  }
}